import { AppUtils } from '../../utils/index';

import { BaseApiModel } from './BaseApiModel';
import { SchadenTypAksApi } from './AksSchadenTypAksApi';
import { SchadenAksKrankheitApi } from './AksSchadenAksKrankheitApi';
import { SchadenAksUnfallApi } from './AksSchadenAksUnfallApi';
import { SchadenAksDokumenteApi } from './AksSchadenAksDokumenteApi';
import { SchadenAksDatenPersonApi } from './AksSchadenAksDatenPersonApi';
import { ZusammenfassungStrukturApi } from './SchadenmeldungZusammenfassungStrukturApi';

/**
 * APIL Url: ADAC.Internet.Core.Models.Schadenmeldung.Aks.SchadenmeldungAks
 * Klasse für die Schadenmeldung beim Auslandskrankenschutz
 * Endpoints: /api/schadenmeldungen/aks
 */
export class SchadenmeldungAksApi extends BaseApiModel {
	constructor(initialProperties?: Partial<SchadenmeldungAksApi>) {
		super();
		if (initialProperties) {
			AppUtils.Helper.mapObject(initialProperties, this);
		}
	}

	protected prozessStufe: number;
	/**
	 * Description: Bearbeitungsstufe im Formular: 0 = Start, 1 = Dokumente, 2 = persönliche Daten, 3 = übersicht mit Speichermöglichkeit
	 * APIL Type: int32
	 */
	get ProzessStufe(): number {
		return this.prozessStufe;
	}

	/**
	 * Description: Bearbeitungsstufe im Formular: 0 = Start, 1 = Dokumente, 2 = persönliche Daten, 3 = übersicht mit Speichermöglichkeit
	 * APIL Type: int32
	 */
	set ProzessStufe(value: number) {
		this.prozessStufe = value;
	}

	protected schadenTyp: SchadenTypAksApi;
	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Core.Models.Schadenmeldung.Aks.SchadenTypAks
	 */
	get SchadenTyp(): SchadenTypAksApi {
		return this.schadenTyp;
	}

	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Core.Models.Schadenmeldung.Aks.SchadenTypAks
	 */
	set SchadenTyp(value: SchadenTypAksApi) {
		this.schadenTyp = value;
	}

	protected datenKrankheit: SchadenAksKrankheitApi;
	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Core.Models.Schadenmeldung.Aks.SchadenAksKrankheit
	 */
	get DatenKrankheit(): SchadenAksKrankheitApi {
		return this.datenKrankheit;
	}

	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Core.Models.Schadenmeldung.Aks.SchadenAksKrankheit
	 */
	set DatenKrankheit(value: SchadenAksKrankheitApi) {
		this.datenKrankheit = value;
	}

	protected datenUnfall: SchadenAksUnfallApi;
	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Core.Models.Schadenmeldung.Aks.SchadenAksUnfall
	 */
	get DatenUnfall(): SchadenAksUnfallApi {
		return this.datenUnfall;
	}

	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Core.Models.Schadenmeldung.Aks.SchadenAksUnfall
	 */
	set DatenUnfall(value: SchadenAksUnfallApi) {
		this.datenUnfall = value;
	}

	protected dokumente: SchadenAksDokumenteApi;
	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Core.Models.Schadenmeldung.Aks.SchadenAksDokumente
	 */
	get Dokumente(): SchadenAksDokumenteApi {
		return this.dokumente;
	}

	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Core.Models.Schadenmeldung.Aks.SchadenAksDokumente
	 */
	set Dokumente(value: SchadenAksDokumenteApi) {
		this.dokumente = value;
	}

	protected persoenlicheDaten: SchadenAksDatenPersonApi;
	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Core.Models.Schadenmeldung.Aks.SchadenAksDatenPerson
	 */
	get PersoenlicheDaten(): SchadenAksDatenPersonApi {
		return this.persoenlicheDaten;
	}

	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Core.Models.Schadenmeldung.Aks.SchadenAksDatenPerson
	 */
	set PersoenlicheDaten(value: SchadenAksDatenPersonApi) {
		this.persoenlicheDaten = value;
	}

	protected id: number;
	/**
	 * Description: Id aus BASS/LAVA - für den Update des Dokuments
	 * APIL Type: int32
	 */
	get Id(): number {
		return this.id;
	}

	/**
	 * Description: Id aus BASS/LAVA - für den Update des Dokuments
	 * APIL Type: int32
	 */
	set Id(value: number) {
		this.id = value;
	}

	protected insisId: string;
	/**
	 * Description: Id aus INSIS
	 * APIL Type: string
	 */
	get InsisId(): string {
		return this.insisId;
	}

	/**
	 * Description: Id aus INSIS
	 * APIL Type: string
	 */
	set InsisId(value: string) {
		this.insisId = value;
	}

	protected dokumentId: string;
	/**
	 * Description: Id des zentralen Dokuments im File Store - entspricht der Vorgangsnummer (ProcessId)
	 * APIL Type: string
	 */
	get DokumentId(): string {
		return this.dokumentId;
	}

	/**
	 * Description: Id des zentralen Dokuments im File Store - entspricht der Vorgangsnummer (ProcessId)
	 * APIL Type: string
	 */
	set DokumentId(value: string) {
		this.dokumentId = value;
	}

	protected strukturUebersichtSeite: ZusammenfassungStrukturApi;
	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Core.Models.Schadenmeldung.ZusammenfassungStruktur
	 */
	get StrukturUebersichtSeite(): ZusammenfassungStrukturApi {
		return this.strukturUebersichtSeite;
	}

	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Core.Models.Schadenmeldung.ZusammenfassungStruktur
	 */
	set StrukturUebersichtSeite(value: ZusammenfassungStrukturApi) {
		this.strukturUebersichtSeite = value;
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): SchadenmeldungAksApi {
		return AppUtils.Helper.createFromMap(dataObject, SchadenmeldungAksApi, (key, value) => {
			switch (key.toLowerCase()) {
				case 'datenkrankheit':
					return SchadenAksKrankheitApi.createFromObject(value);
				case 'datenunfall':
					return SchadenAksUnfallApi.createFromObject(value);
				case 'dokumente':
					return SchadenAksDokumenteApi.createFromObject(value);
				case 'persoenlichedaten':
					return SchadenAksDatenPersonApi.createFromObject(value);
				case 'strukturuebersichtseite':
					return ZusammenfassungStrukturApi.createFromObject(value);
				default:
					return value;
			}
		});
	}

	public toRequestObject(): { [key: string]: any } {
		const result: { [key: string]: any } = {};
		result.ProzessStufe = this.prozessStufe;
		result.SchadenTyp = this.schadenTyp;
		if (this.datenKrankheit) {
			result.DatenKrankheit = this.datenKrankheit.toRequestObject();
		}
		if (this.datenUnfall) {
			result.DatenUnfall = this.datenUnfall.toRequestObject();
		}
		if (this.dokumente) {
			result.Dokumente = this.dokumente.toRequestObject();
		}
		if (this.persoenlicheDaten) {
			result.PersoenlicheDaten = this.persoenlicheDaten.toRequestObject();
		}
		result.Id = this.id;
		result.InsisId = this.insisId;
		result.DokumentId = this.dokumentId;
		if (this.strukturUebersichtSeite) {
			result.StrukturUebersichtSeite = this.strukturUebersichtSeite.toRequestObject();
		}
		return result;
	}

	public toJsonString(): string {
		return JSON.stringify(this.toRequestObject());
	}
}